import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { spaces } from "@/react/helpers/urlHelpers";
import type { Space } from "@/react/types";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { MODAL_SIZES } from "@circle-react-uikit/ModalV2/ModalContent";
import { Typography } from "@circle-react-uikit/Typography";

interface CongratulationsModalProps {
  space?: Space;
}

export const CongratulationsModalComponent = ({
  space,
}: CongratulationsModalProps) => {
  const modal = useModal();
  const history = useHistory();
  const confettiEmoji = "🎉";
  const goToCourseHomepage = () => {
    modal.remove();
    if (!space?.slug) return;
    history.push(spaces.show({ spaceSlug: space.slug }));
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={modal.remove}
      contentPortalId="course-congratulations-modal"
    >
      <Modal.Overlay />
      <Modal.Content size={MODAL_SIZES.sm}>
        <Modal.Header className="!justify-end">
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={modal.remove} />
          </Modal.HeaderActions>
        </Modal.Header>
        <div
          className="flex w-full flex-col px-8 pb-5 text-center"
          data-testid="course-completed"
        >
          <p className="mb-4 text-6xl">{confettiEmoji}</p>
          <Typography.TitleMd>
            {t("courses.view_lesson.congratulations_modal.title")}
          </Typography.TitleMd>
          <p className="mt-3">
            <Typography.LabelMd>
              {t("courses.view_lesson.congratulations_modal.body")}
            </Typography.LabelMd>
            &nbsp;
            <Typography.LabelMd weight="semibold">
              {space?.name}
            </Typography.LabelMd>
          </p>
          <Button
            variant="circle"
            className="mt-12"
            onClick={goToCourseHomepage}
          >
            {t("courses.view_lesson.congratulations_modal.cta_button_text")}
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  );
};
const CongratulationsModal = ModalManager.create(
  (props: CongratulationsModalProps) => (
    <CongratulationsModalComponent {...props} />
  ),
);
export const useCongratulationsModal = () => useModal(CongratulationsModal);
